module.exports = __webpack_public_path__ + "static/media/END CAP PLAIN END FOR 280 TUBE FOR SDS 300.24d740ac.jpg";